export default __webpack_public_path__ + "static/media/01d.d27a95c2.png";